module.exports = __webpack_public_path__ + "static/missionNoob1-d274fe983b065c0e31e981c9b7998938.png";